import { CheckCircleOutlined } from '@ant-design/icons';
import { Tag, Typography } from 'antd';
import { useSimulation } from '../../context/SimulationContext';
import './TurnFeedbackBanner.scss';

function TurnFeedbackBanner() {
  const { turnIndex, actionsDetected, actionText } = useSimulation();

  // Only show after at least one turn has been completed and the input is empty
  if (turnIndex === 0 || actionText.length > 0) return null;

  return (
    <div className="turn-feedback-banner">
      <div className="turn-feedback-header">
        <CheckCircleOutlined className="turn-feedback-check" />
        <Typography.Text strong>Turn {turnIndex} accepted</Typography.Text>
        {actionsDetected.length > 0 && (
          <div className="turn-feedback-actions">
            {actionsDetected.map((action) => (
              <Tag key={action} color="blue">
                {action}
              </Tag>
            ))}
          </div>
        )}
      </div>
      <Typography.Text type="secondary" className="turn-feedback-hint">
        Check the <Typography.Text strong>Status Indicators</Typography.Text> on
        the right to see how your decision impacted the evaluation, then describe
        your next action below.
      </Typography.Text>
    </div>
  );
}

export default TurnFeedbackBanner;
